var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
var Container = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var Icon = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-left: calc(var(--spacing) * 1);\n  line-height: 0;\n"], ["\n  padding-left: calc(var(--spacing) * 1);\n  line-height: 0;\n"])));
export default (function (props) {
    return (_jsxs(Container, { children: [_jsx("div", { children: props.label }), props.icon && _jsx(Icon, { children: props.icon })] }));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map